"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCustomDate = formatCustomDate;
exports.formatAbsoluteDate = formatAbsoluteDate;
exports.convertUTCDateToLocalDate = convertUTCDateToLocalDate;
exports.convertToFormattedUserTimeZone = convertToFormattedUserTimeZone;
const luxon_1 = require("luxon");
function formatCustomDate(date, excludeTime) {
    //in format: Dec 17, 2023 11:31 pm
    const options = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    };
    // Format the date
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(new Date(date));
    // If the formatted date includes "at", we remove it
    const adjustedDate = formattedDate.replace(" at", ",");
    // Split the formatted date and time to adjust the format
    const [datePart, yearPart, timePart] = adjustedDate.split(", ");
    return `${datePart}.${yearPart}${excludeTime ? `` : ` | ${timePart.toLowerCase()}`}`;
}
function formatAbsoluteDate(date) {
    const utcDate = new Date(date); // The date input is already in UTC format (with "Z")
    // Extract the date components (year, month, day) in UTC
    const year = utcDate.getUTCFullYear();
    const month = utcDate.getUTCMonth(); // 0-based (0 = January, 1 = February, etc.)
    const day = utcDate.getUTCDate();
    const formattedDate = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
    }).format(new Date(year, month, day));
    return formattedDate;
}
function convertUTCDateToLocalDate(utcDate) {
    const date = new Date(utcDate);
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate;
}
function convertToFormattedUserTimeZone(utcTime, userTimeZone, excludeTime = false) {
    // Convert the UTC Date object to a DateTime object in UTC
    const utcDateTime = luxon_1.DateTime.fromJSDate(utcTime).setZone("utc");
    // Convert to the user's local time zone
    const localDateTime = utcDateTime.setZone(userTimeZone);
    // Get the time zone name in a more user-friendly format
    const timeZoneName = localDateTime.toFormat("ZZZZ"); // 'ZZZZ' will give the short form (like EST, PST, etc.)
    const timeZoneFullName = localDateTime.toFormat("ZZZZZ"); // 'ZZZZZ' will give the full form (like Eastern Standard Time)
    // Return the formatted string with time and optionally time zone
    return `${localDateTime.toFormat(`yyyy-MM-dd${excludeTime ? "" : " hh:mm a"}`)} (${timeZoneFullName})`;
}
